import {
  ApiBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import radarData from './radar.json';

const techRadarApi = ApiBlueprint.make({
  name: 'tech-radar',
  params: defineParams =>
    defineParams({
      api: techRadarApiRef,
      deps: {},
      factory: () => ({
        async load() {
          return {
            ...radarData,
            entries: radarData.entries.map(entry => ({
              ...entry,
              timeline: entry.timeline.map(t => ({
                ...t,
                date: new Date(t.date),
              })),
            })),
          };
        },
      }),
    }),
});

export const techRadarModule = createFrontendModule({
  pluginId: 'tech-radar',
  extensions: [techRadarApi],
});